import { getDisplayName } from '@mui/utils'
import * as types from './actionTypes'
import { updateMappedImage } from 'mappers/inventoryMapper'

export const initialState = {
  requestPending: false,
  requestSuccess: false,
  requestFailure: false,
  virtualBundles: [],
  totalRowsCount: 0,
  selectedVirtualBundleDetails: {},
  virtualBundlesFromItems: [],
  virtualBundlesFromSearch: [],
  virtvirtualBundlesFromSearchTotalPagesCount: 0,
  virtualBundlesFromSearchTotalRowsCount: 0,
  page: 1,
  rowsPerPage: 25,
  csvDownloadData: [],
}

export default function virtualBundlesReducer(state = {}, action) {
  switch (action.type) {
    case types.SET_VIRTUAL_BUNDLES_REQUEST_PENDING: {
      return {
        ...state,
        requestPending: action.payload,
      }
    }
    case types.SET_VIRTUAL_BUNDLES_REQUEST_SUCCESS: {
      return {
        ...state,
        requestSuccess: true,
        virtualBundles: [...action.payload.data],
        totalRowsCount: action.payload?.totalRowsCount || 0,
      }
    }
    case types.SET_SELECTED_VIRTUAL_BUNDLE_DETAILS: {
      return {
        ...state,
        selectedVirtualBundleDetails: action.payload,
      }
    }
    case types.GET_A_VIRTUAL_BUNDLES_REQUEST_PENDING: {
      return {
        ...state,
        virtualBundleRequestPending: action.payload,
      }
    }
    case types.SET_VIRTUAL_BUNDLES_PAGE: {
      return {
        ...state,
        page: action.payload,
      }
    }
    case types.SET_VIRTUAL_BUNDLES_ROWS_PER_PAGE: {
      return {
        ...state,
        rowsPerPage: action.payload,
      }
    }
    case types.GET_A_VIRTUAL_BUNDLE_DATA_SUCCESS: {
      return {
        ...state,
        virtualBundlesFromSearch: action.payload.data.map((item) => {
          return {
            ...item,
            ...updateMappedImage(item),
          }
        }),
        virtvirtualBundlesFromSearchTotalPagesCount:
          action.payload?.pagesCount || 0,
        virtualBundlesFromSearchTotalRowsCount: action.payload?.totalCount || 0,
      }
    }
    case types.SET_VIRTUAL_BUNDLE_PARENT: {
      return {
        ...state,
        virtualBundleParent: action.payload.data,
      }
    }
    case types.SHOW_VIRTUAL_BUNDLE_POPUP:
      return Object.assign({}, state, {
        ...state,
        popupIsVisible: true,
        item: action.payload.item,
      })
    case types.CLOSE_VIRTUAL_BUNDLE_POPUP:
      return Object.assign({}, state, {
        ...state,
        popupIsVisible: false,
      })
    case types.SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_PENDING: {
      return Object.assign({}, state, {
        ...state,
        csvDownloadPending: action.payload,
      })
    }
    case types.SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_SUCCESS: {
      return Object.assign({}, state, {
        ...state,
        csvDownloadData: action.payload,
      })
    }
    case types.VIRTUAL_BUNDLE_CALL_EDIT_FIELDS_API: {
      const { virtualBundlesFromSearch = [] } = state
      const {
        payload: { data: payloadData, sample_id },
      } = action
      const newDataObj = (virtualBundlesFromSearch || []).map((obj) => {
        if (obj?.pegasusId?.indexOf(sample_id) !== -1) {
          obj = Object.assign({}, obj, payloadData)
        }
        return obj
      })
      return Object.assign({}, state, {
        ...state,
        virtualBundlesFromSearch: newDataObj,
      })
    }
    case types.SET_VIRTUAL_BUNDLES_FROM_ITEMS: {
      return Object.assign({}, state, {
        ...state,
        virtualBundlesFromItems: action.payload.data.map((item) => ({
          ...item,
          imagePopupUrl: item?.imageUrl || '',
          imageUrl: item?.imageUrl
            ? getDisplayName(item.imageUrl)
            : 'Image Not Found',
        })),
      })
    }
    default:
      return state
  }
}
